export default "__VITE_ASSET__CYaCX4$C__"